export const GET_USERS_BEGIN = 'get_users_begin';
export const GET_USERS_REQUESTING = 'get_users_requesting';
export const GET_USERS_SUCCESS = 'get_users_success';
export const GET_USERS_ERROR = 'get_users_error';

export const GET_USER_BEGIN = 'get_user_begin';
export const GET_USER_REQUESTING = 'get_user_requesting';
export const GET_USER_SUCCESS = 'get_user_success';
export const GET_USER_ERROR = 'get_user_error';
export const GET_USER_RESET = 'get_user_reset';

export const SET_USER_BEGIN = 'set_user_begin';
export const SET_USER_REQUESTING = 'set_user_requesting';
export const SET_USER_SUCCESS = 'set_user_success';
export const SET_USER_ERROR = 'set_user_error';
export const SET_USER_RESET = 'set_user_reset';

export const UPDATE_USER_BEGIN = 'update_user_begin';
export const UPDATE_USER_REQUESTING = 'update_user_requesting';
export const UPDATE_USER_SUCCESS = 'update_user_success';
export const UPDATE_USER_ERROR = 'update_user_error';
export const UPDATE_USER_RESET = 'update_user_reset';

export const UPDATE_USER_ADMIN_BEGIN = 'get_user_admin_begin';
export const UPDATE_USER_ADMIN_REQUESTING = 'get_user_admin_requesting';
export const UPDATE_USER_ADMIN_SUCCESS = 'get_user_admin_success';
export const UPDATE_USER_ADMIN_ERROR = 'get_user_admin_error';
export const UPDATE_USER_ADMIN_RESET = 'get_user_admin_reset';

export const DELETE_USER_BEGIN = 'delete_user_begin';
export const DELETE_USER_REQUESTING = 'delete_user_requesting';
export const DELETE_USER_SUCCESS = 'delete_user_success';
export const DELETE_USER_ERROR = 'delete_user_error';
export const DELETE_USER_RESET = 'delete_user_reset';

export const GET_USERS_BY_COURSES_BEGIN = 'get_users_by_courses_begin';
export const GET_USERS_BY_COURSES_REQUESTING = 'get_users_by_courses_requesting';
export const GET_USERS_BY_COURSES_SUCCESS = 'get_users_by_courses_success';
export const GET_USERS_BY_COURSES_ERROR = 'get_users_by_courses_error';
export const GET_USERS_BY_COURSES_RESET = 'get_users_by_courses_reset';

export const GET_USERS_BY_TRAININGS_BEGIN = 'get_users_by_trainings_begin';
export const GET_USERS_BY_TRAININGS_REQUESTING = 'get_users_by_trainings_requesting';
export const GET_USERS_BY_TRAININGS_SUCCESS = 'get_users_by_trainings_success';
export const GET_USERS_BY_TRAININGS_ERROR = 'get_users_by_trainings_error';
export const GET_USERS_BY_TRAININGS_RESET = 'get_users_by_trainings_reset';

export const UPDATE_USER_BY_TRAINING_BEGIN = 'get_user_by_training_begin';
export const UPDATE_USER_BY_TRAINING_REQUESTING = 'get_user_by_training_requesting';
export const UPDATE_USER_BY_TRAINING_SUCCESS = 'get_user_by_training_success';
export const UPDATE_USER_BY_TRAINING_ERROR = 'get_user_by_training_error';
export const UPDATE_USER_BY_TRAINING_RESET = 'get_user_by_training_reset';

